import React, { useEffect, useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { Cookies } from "react-cookie";

const cookies = new Cookies();
const HIDE_COOKIE_KEY = "hide_chuseok_event_2026";
const EVENT_END = new Date("2026-09-24T23:59:59+09:00");

function ChuseokEventModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (new Date() > EVENT_END) return;
    if (cookies.get(HIDE_COOKIE_KEY)) return;
    setIsOpen(true);
  }, []);

  const handleClose = () => setIsOpen(false);

  const handleHide24h = () => {
    const expires = new Date();
    expires.setHours(expires.getHours() + 24);
    cookies.set(HIDE_COOKIE_KEY, "true", { path: "/", expires });
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered size="md">
      <ModalBody className="p-4">
        <h5 className="fw-bold text-center mb-3">
          추석맞이 PETER&JOHN 할인 행사 안내
        </h5>
        <p>
          안녕하세요, 헬스인사이드입니다.
          <br />
          다가오는 추석을 맞아 PETER&amp;JOHN 전 제품 할인 행사를
          준비했습니다.
        </p>
        <ul className="mb-3">
          <li>
            <b>기간</b>: 9월 1일 ~ 9월 25일 오전 접수 건까지
          </li>
          <li>
            <b>혜택</b>: 한국 판매가 최대 20% 할인 + 헬스인사이드 공급가 10%
            추가 지원
          </li>
          <li>
            <b>대상</b>: PETER&amp;JOHN 전 제품 (화장품·치약 제외)
          </li>
          <li>
            <b>참여</b>: 업체별 자율 참여 (미참여 시에도 평소와 동일하게 주문
            가능)
          </li>
        </ul>
        <p className="text-muted small mb-0">
          * 이미 특별공급가가 적용 중인 일부 품목은 공급가 10% 추가 할인에서
          제외되며(한국 판매가 20% 할인은 동일 적용 가능), 자세한 내용은
          담당자에게 문의해 주세요.
        </p>
      </ModalBody>
      <div className="d-flex border-top">
        <Button
          color="light"
          className="w-50 rounded-0"
          onClick={handleHide24h}
        >
          24시간 동안 보지 않기
        </Button>
        <Button color="dark" className="w-50 rounded-0" onClick={handleClose}>
          닫기
        </Button>
      </div>
    </Modal>
  );
}

export default ChuseokEventModal;
